function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M5.268 9a2 2 0 013.464 0H15a1 1 0 010 2H8.732a2 2 0 01-3.464 0H1a1 1 0 010-2h4.268zm5-4a2 2 0 013.464 0H15a1 1 0 010 2h-1.268a2 2 0 01-3.464 0H1a1 1 0 110-2h9.268zm-6-4a2 2 0 013.464 0H15a1 1 0 010 2H7.732a2 2 0 01-3.464 0H1a1 1 0 110-2h3.268z"
});

var SvgTrait = function SvgTrait(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12"
  }, props), _ref);
};

export default SvgTrait;